import type React from 'react';

import { observer } from 'mobx-react';

import useEmailWarningState from 'dmarc/hooks/email-warning-state';

import { withSecure } from 'tm3-core/controls/security/secure';

import EmailWarningDialog from './dialog';

export interface IProps {}

const EmailWarning: React.FC<IProps> = observer(() => {
  const { acknowledged } = useEmailWarningState();

  const cachedUserId = parseInt(localStorage.getItem('cache:userId') || '') || -1;
  const tempDismissedDmarc = localStorage.getItem(`${cachedUserId}:dmarc-dismiss-timestamp`) || '';

  let tempDismissedDmarcRecent = false;
  if (tempDismissedDmarc) {
    const dimissedExpires = new Date(tempDismissedDmarc);
    dimissedExpires.setDate(dimissedExpires.getDate() + 1);

    tempDismissedDmarcRecent = dimissedExpires >= new Date();
  }

  if (acknowledged || tempDismissedDmarcRecent) {
    return null;
  }

  return <EmailWarningDialog />;
});

EmailWarning.displayName = 'EmailWarning';

export default withSecure(EmailWarning, ['/Administrative/TM2 Options/DMARC Options']);
